import { useState, useEffect } from "react";
import {
  getSeoDefaults,
  getSeoPages,
  buildRouteSeo,
  buildProductSeo,
  buildCategorySeo,
} from "../utils/seo";

export const useRouteSeo = (path) => {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    let alive = true;
    Promise.all([getSeoDefaults(), getSeoPages()]).then(([defaults, pages]) => {
      if (alive) setSeo(buildRouteSeo(path, defaults, pages));
    });
    return () => {
      alive = false;
    };
  }, [path]);

  return seo;
};

export const useProductSeo = (product) => {
  const [seo, setSeo] = useState(null);
  const productId = product?._id;

  useEffect(() => {
    if (!productId) return;
    let alive = true;
    getSeoDefaults().then((defaults) => {
      if (alive) setSeo(buildProductSeo(product, defaults));
    });
    return () => {
      alive = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  return seo;
};

export const useCategorySeo = (category, subcategory) => {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    if (!category) return;
    let alive = true;
    Promise.all([getSeoDefaults(), getSeoPages()]).then(([defaults, pages]) => {
      if (alive) setSeo(buildCategorySeo(category, subcategory, defaults, pages));
    });
    return () => {
      alive = false;
    };
  }, [category, subcategory]);

  return seo;
};
